<template>
  <el-form ref="form" :model="formData" :rules="rules" size="small">
    <el-row :gutter="20">
      <el-col
        :xs="{ span: 20 }"
        :sm="{ span: 12 }"
        :md="{ span: 12 }"
        :lg="{ span: 12 }"
      >
        <el-form-item
          :label="$l('form_label_category') || '分类'"
          prop="masterCategoryCode"
        >
          <!--            <el-cascader clearable v-model="formData.categoryCodeArray" style="width: 100%"-->
          <!--                         v-if="isCascaderInit" :props="masterCategoryProps" :disabled="disabled">-->
          <!--            </el-cascader>-->
          <dict-select
            style="width:100%;"
            :placeholder="$l('form_label_category') || '分类'"
            filterable
            clearable
            v-model="formData.masterCategoryCode"
            size="medium"
            url="/digitalCenter/common/dict/masterCategory"
            disabled
          >
          </dict-select>
        </el-form-item>
      </el-col>
      <el-col
        :xs="{ span: 20 }"
        :sm="{ span: 12 }"
        :md="{ span: 12 }"
        :lg="{ span: 12 }"
      >
        <el-form-item
          :label="$l('form_label_column_type') || '字段类型'"
          prop="resInputColumnType"
        >
          <el-select
            style="width: 100%;"
            @change="changeColumn"
            v-model="formData.resInputColumnType"
            :disabled="disabled"
            filterable
            :placeholder="$l('form_label_column_type') || '字段类型'"
            size="medium"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col
        :xs="{ span: 20 }"
        :sm="{ span: 12 }"
        :md="{ span: 12 }"
        :lg="{ span: 12 }"
      >
        <el-form-item
          :label="$l('form_label_column_name') || '字段名称'"
          prop="resInputColumnDisplay"
        >
          <el-input
            size="medium"
            v-model="formData.resInputColumnDisplay"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col
        :xs="{ span: 20 }"
        :sm="{ span: 12 }"
        :md="{ span: 12 }"
        :lg="{ span: 12 }"
      >
        <el-form-item
          :label="$l('form_label_attribute_type') || '属性类型'"
          prop="resInputColumnName"
        >
          <dict-select
            size="medium"
            v-if="formData.resInputColumnType == 'select'"
            :disabled="disabled"
            v-model="formData.resInputColumnName"
            filterable
            clearable
            url="/digitalCenter/common/dict/researchDict"
            :placeholder="$l('form_label_attribute_type') || '属性类型'"
            style="width: 100%"
          ></dict-select>
          <el-input
            size="medium"
            v-else-if="formData.resInputColumnType === 'input'"
            v-model="formData.resInputColumnName"
            :placeholder="$l('form_label_attribute_type') || '属性类型'"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col
        :xs="{ span: 20 }"
        :sm="{ span: 12 }"
        :md="{ span: 12 }"
        :lg="{ span: 12 }"
      >
        <el-form-item
          :label="$l('form_label_is_visiable') || '是否显示'"
          prop="isVisible"
        >
          <el-radio-group
            size="medium"
            style="width: 100%;"
            :disabled="disabled"
            v-model="formData.isVisible"
          >
            <el-radio label="Y">{{
              $l('form_radio_label_yes') || '是'
            }}</el-radio>
            <el-radio label="N">{{
              $l('form_radio_label_no') || '否'
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col
        :xs="{ span: 20 }"
        :sm="{ span: 12 }"
        :md="{ span: 12 }"
        :lg="{ span: 12 }"
      >
        <el-form-item
          :label="$l('form_label_is_multiselect') || '是否多选'"
          prop="isMultiselect"
        >
          <el-radio-group
            size="medium"
            style="width: 100%;"
            :disabled="disabled"
            v-model="formData.isMultiselect"
          >
            <el-radio label="Y">{{
              $l('form_radio_label_yes') || '是'
            }}</el-radio>
            <el-radio label="N">{{
              $l('form_radio_label_no') || '否'
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col
        :xs="{ span: 20 }"
        :sm="{ span: 12 }"
        :md="{ span: 12 }"
        :lg="{ span: 12 }"
      >
        <el-form-item
          :label="$l('form_label_is_required') || '是否必输项'"
          prop="isRequired"
        >
          <el-radio-group
            size="medium"
            style="width: 100%;"
            :disabled="disabled"
            v-model="formData.isRequired"
          >
            <el-radio label="Y">{{
              $l('form_radio_label_yes') || '是'
            }}</el-radio>
            <el-radio label="N">{{
              $l('form_radio_label_no') || '否'
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col
        :xs="{ span: 20 }"
        :sm="{ span: 12 }"
        :md="{ span: 12 }"
        :lg="{ span: 12 }"
      >
        <el-form-item
          :label="$l('form_label_sortorder') || '排序顺序'"
          prop="sortOrder"
        >
          <el-input
            size="medium"
            v-model="formData.sortOrder"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col v-if="formData.resTemplateCode">
        <div style="font-size: 14px; color: #606266;">
          <span
            >Create：{{ formData.createByName }} at
            {{ formData.createDate }}</span
          >
          <el-divider direction="vertical"></el-divider>
          <span
            >Modify：{{ formData.modifyByName }} at
            {{ formData.modifyDate }}</span
          >
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  props: {
    params: {
      default: null,
      type: Object,
    },
  },
  data() {
    let that = this
    return {
      options: [
        {
          value: 'input',
          label: this.$l('form_option_select_label_text') || '文字',
        },
        {
          value: 'select',
          label: this.$l('form_option_select_label_option') || '选项',
        },
      ],
      disabled: false,
      researchDictList: [],
      isCascaderInit: false,
      masterCategoryProps: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node
          let parentCode
          if (level === 0) {
            parentCode = 0
          } else {
            parentCode = node.value
          }
          that.$api.masterCategory({ parentCode: parentCode }).then((res) => {
            let data = res.body.data
            data.forEach((item) => {
              if (item.isLast === 'Y') {
                item.leaf = true
              } else {
                item.leaf = false
              }
            })
            resolve(data)
          })
        },
      },
      formData: {
        resTemplateCode: '',
        categoryCodeArray: [],
        resInputColumnName: '',
        resInputColumnDisplay: '',
        resInputColumnType: 'input',
        isMultiselect: 'Y',
        isRequired: 'Y',
        isVisible: 'Y',
        sortOrder: '',
        createByName: '',
        createDate: '',
        modifyByName: '',
        modifyDate: '',
      },
      rules: {
        masterCategoryCode: [
          {
            required: true,
            message: this.$l('form_rule_message_category') || '请选择分类',
            trigger: 'blur',
          },
        ],
        resInputColumnName: [
          {
            required: true,
            message:
              this.$l('form_rule_message_attribute_type') || '请输入属性字典',
            trigger: 'blur',
          },
        ],
        resInputColumnDisplay: [
          {
            required: true,
            message:
              this.$l('form_rule_message_column_name') || '请输入字段名称',
            trigger: 'blur',
          },
        ],
        resInputColumnType: [
          {
            required: true,
            message:
              this.$l('form_rule_message_column_type') || '请选择字段类型',
            trigger: 'blur',
          },
        ],
        isVisible: [
          {
            required: true,
            message:
              this.$l('form_rule_message_visible_status') || '请选择显示状态',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    // 加载表单数据（新增，编辑，详情）
    fromLoad(ref, val = '') {
      this.init()
      this.isCascaderInit = true
      if (ref !== 'add') {
        let param = { resTemplateCode: val }
        this.$api.detailResearchInputTemplateApi(param).then((res) => {
          this.formData = res.body
        })
        // 控制组件不可编辑
        if (ref === 'detail') {
          this.disabled = true
        }
      } else {
        this.formData.masterCategoryCode = this.params.masterCategoryCode
      }
    },
    selectResearchDict() {
      this.$api.researchDict().then((res) => {
        this.researchDictList = res.body.data
      })
    },
    changeColumn() {
      this.formData.resInputColumnName = ''
    },
    // 保存数据
    save() {
      // 校验表单正确性
      this.$refs.form.validate((valid) => {
        if (valid) {
          // let categoryCodeArray = this.formData.categoryCodeArray
          // this.formData.masterCategoryCode = categoryCodeArray[0]
          // this.formData.categoryCode = categoryCodeArray[1] ? categoryCodeArray[1] : ''
          this.$api.saveResearchInputTemplateApi(this.formData).then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功',
              type: 'success',
            })
            // 通知父组件保存成功
            this.$emit('success')
          })
        } else {
          return false
        }
      })
    },
    // 初始化表单数据
    init() {
      this.disabled = false
      this.isCascaderInit = false
      this.researchDictList = []
      this.selectResearchDict()
      if (this.$refs.form) {
        this.$refs.form.resetFields()
        this.formData = {
          resTemplateCode: '',
          categoryCodeArray: [],
          resInputColumnName: '',
          resInputColumnDisplay: '',
          resInputColumnType: 'input',
          isMultiselect: 'Y',
          isRequired: 'Y',
          isVisible: 'Y',
          sortOrder: '',
          createByName: '',
          createDate: '',
          modifyByName: '',
          modifyDate: '',
        }
      }
    },
  },
}
</script>
